<template>
  <g>
    <defs>
      <path
        id="location-a"
        d="M12.058576,13.0538686 C13.1972741,13.0538686 14.1203713,12.1307714 14.1203713,10.9920733 C14.1203713,9.85337523 13.1972741,8.93027804 12.058576,8.93027804 C10.9198779,8.93027804 9.99678071,9.85337523 9.99678071,10.9920733 C9.99678071,12.1307714 10.9198779,13.0538686 12.058576,13.0538686 Z M11.3266387,20.1773713 C11.5202068,20.3725333 11.7837,20.4823091 12.058576,20.4823091 C12.333452,20.4823091 12.5969452,20.3725333 12.7905133,20.1773713 L17.0068847,15.950691 C19.0095707,13.9490516 19.6091141,10.9380279 18.5258933,8.32193456 C17.4426725,5.70584123 14.8900618,4 12.058576,4 C9.22709022,4 6.67447949,5.70584123 5.59125866,8.32193456 C4.50803784,10.9380279 5.10758129,13.9490516 7.11026731,15.950691 L11.3266387,20.1773713 Z M7.14119424,10.5178604 C7.28384556,9.02926906 8.0906733,7.68455616 9.33700622,6.85817377 C10.9892274,5.77333769 13.1279245,5.77333769 14.7801458,6.85817377 C16.0179143,7.68156137 16.821994,9.01589788 16.9716967,10.4949608 C17.1213994,11.9740238 16.6009969,13.4424172 15.553319,14.4971253 L12.058576,17.9918683 L8.56383299,14.4971253 C7.51478497,13.4524874 6.99221576,11.9908083 7.14119424,10.5178604 L7.14119424,10.5178604 Z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <rect
        width="24"
        height="24"
        fill="#E3E3E3"
        fill-opacity=".01"
        style="mix-blend-mode:color-burn"
      />
      <use :fill="currentColor" :opacity="opacity" fill-rule="nonzero" xlink:href="#location-a" />
    </g>
  </g>
</template>

<script>
  export default {
    props: {
      currentColor: {
        type: String,
        default: 'black'
      },
      opacity: {
        type: String,
        default: '1'
      }
    }  
  }
</script>